// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1b6vs","bulletPoint":"styles_bulletPoint__2G4PO"};